import classNames from "classnames";
import React from "react";
import { lookupColourString, lookupHeight } from "../lookups";

export function buildBackgroundGradientClassName(
  gradientType?: Queries.GraphCMS_GradientType,
  gradientColour?: Queries.GraphCMS_Colour,
): string | undefined {
  if (gradientType && gradientColour) {
    return classNames(
      "bg-gradient-to-b",
      lookupHeight(gradientType),
      lookupColourString(gradientColour, "from"),
    );
  }
  return undefined;
}

export const BackgroundGradient: React.FC<{
  gradientType?: Queries.GraphCMS_GradientType | null;
  gradientColour?: Queries.GraphCMS_Colour | null;
  className?: string;
}> = ({ gradientType, gradientColour, className }) => {
  if (!(gradientColour && gradientType)) {
    return null;
  }
  return (
    <div
      className={classNames(
        "absolute w-full",
        className,
        buildBackgroundGradientClassName(gradientType, gradientColour),
      )}
    />
  );
};
